import React from "react";
import Svg, { ClipPath, Defs, G, Path, Rect } from "react-native-svg";

type Avatar4Colors = {
  background?: string;
  skin?: string;
  hair?: string;
};

export const Avatar4 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar4Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar4" clipPath="url(#clip0_2286_5734)">
        <Path
          id="background"
          d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
          fill={c.background}
        />
        <Path
          id="skin"
          d="M212.304 162.322c1.752-11.739.048-11.357.048-25.254 1.601-37.662-2.652-83.08-37.749-83.08-63.37 0-69.709 28.702-69.709 70.784 0 2.19.096 4.428.287 6.689-1.227-.111-2.597.08-4.157.638-4.747 1.696-6.18 9.811-3.21 18.118 2.971 8.306 9.23 13.666 13.969 11.969.318-.111.621-.262.908-.43 2.397 5.822 8.465 56.911 6.881 63.577-2.565 10.775-15.562 17.624-15.562 17.624s52.714 55.39 79.003 52.865c15.944-.334 13.546-41.628 13.546-41.628s-14.55-5.766-18.11-12.439c-1.513-2.836-.621-18.883.016-30.415 9.581-1.123 21.734-15.291 33.823-49.026l.016.008Z"
          fill={c.skin}
        />
        <Path
          id="Vector"
          d="M127.217 121.172s10.982-3.098 19.559-2.931c10.075.199 17.242 6.586 19.138 3.393.605-1.02.111-6.411-18.278-8.418-8.226-.9-13.013 2.644-20.419 7.948v.008Z"
          fill="#000"
        />
        <Path
          id="Vector_2"
          d="M212.153 117.572c-22.984-2.692-28.806 5.79-27.508 7.709.805 1.187 2.788 1.33 4.603-.008 3.823-3.966 10.736-5.766 22.714-3.209.31-1.354.215-3.353.191-4.484v-.008Z"
          fill="#000"
        />
        <Path
          id="Vector_3"
          d="M161.637 134.384c-2.484-4.404-6.618-8.458-11.794-9.445a13.975 13.975 0 0 0-6.913.876c-1.816.717-3.217 1.911-4.563 3.098-1.824 1.306-4.245.804-6.443.542 2.07 1.497 5.145 2.699 7.661 1.417a22.516 22.516 0 0 1 1.752-1.059c-.016.191-.04.374-.04.573a6.341 6.341 0 0 0 6.34 6.34 6.336 6.336 0 0 0 6.339-6.34c0-.286-.024-.565-.064-.844 2.485 1.179 4.978 2.923 7.725 4.842Z"
          fill="#000"
        />
        <Path
          id="Vector_4"
          d="M184.645 125.281c-.239-.35-.231-.932.072-1.616-8.657 12.845 3.297 33.52-1.362 37.414-3.257 2.724-15.57-1.083-16.047 2.398 4.483 2.93 16.828 5.264 20.563-1.506 1.465-3.496-8.211-26.751 1.377-36.706-1.815 1.338-3.806 1.195-4.603.008v.008Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <Path
          id="Vector_5"
          d="M145.39 220.849c12.145 10.999 24.02 14.343 31.848 15.211-.143-6.45.398-16.198.821-23.923-.375.039-.741.071-1.099.079-13.077.168-28.392-3.775-42.409-16.581-5.105-4.659-9.676-10.257-13.618-16.406 0 .407-.016.821-.016 1.243 1.967 9.079 7.701 25.182 24.481 40.369l-.008.008Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
        <Path
          id="hair"
          d="m85.629 251.208 17.974-7.462c58.034-17.163 7.431-62.438 6.109-98.722 0-16.493 20.985-19.854 28.535-24.927 12.407-7.948 40.481-34.548 41.627-49.25 0 0 31.1 31.355 31.092 31.339 1.377 11.579 1.457 23.995.963 35.67 0 13.89 1.705 13.515-.047 25.254-12.082 33.736-24.243 47.912-33.823 49.027-1.617 29.196-4.189 33.703 18.094 42.846 6.156 1.234 14.176 4.038 22.243 6.761 25.349-24.218 34.771-52.968 20.364-96.579-15.864-41.739 5.734-107.29-55.541-116.33-27.412-34.994-86.321-1.37-101.405 59.833-21.145 74.328-20.985 99.168 3.807 142.532l.008.008Z"
          fill={c.hair}
        />
        <Path
          id="Vector_6"
          d="M210.201 131.525c-1.345-1.187-2.747-2.381-4.563-3.098-2.222-.892-4.579-1.163-6.913-.876-5.184.987-9.31 5.041-11.794 9.445a133.314 133.314 0 0 1 4.061-2.763 5.974 5.974 0 0 0 5.949 5.503 5.975 5.975 0 0 0 5.973-5.973 5.962 5.962 0 0 0-.86-3.058c2.135.247 4.404 1.107 6.929 2.787 2.517 1.29 5.591.088 7.661-1.418-2.198.263-4.619.765-6.443-.541v-.008Z"
          fill="#000"
        />
        <Path
          id="Vector_7"
          d="M196.161 254.983s2.397 40.497-13.547 40.831c-26.297 2.533-79.003-52.857-79.003-52.865l-53.032 22.005c26.87 24.067 62.35 38.705 101.262 38.705 35.161 0 67.527-11.954 93.266-32.024-13.053-5.55-35.392-13.785-48.938-16.66l-.008.008Z"
          fill="#000"
        />
        <Path
          id="Vector_8"
          d="M154.685 175.853c.756.677 11.245 13.013 22.992 12.567 10.01-.382 13.252-10.536 13.491-11.046 0 0-4.428-4.38-7.502-4.261-3.075.12-5.225 1.689-5.225 1.689s-2.771-1.713-6.037-1.593c-3.265.119-6.18 1.887-9.238 2.421-3.09.533-8.481.223-8.481.223Zm4.228 1.975c-.087-.048 0-.143.088-.112 3.743 1.394 10.242 2.334 20.3 1.952 5.185-.199 8.617-.375 11.452-1.346-2.827 1.21-6.554 4.46-11.731 4.659-10.09.382-16.405-3.098-20.109-5.153Z"
          fill="#2E2017"
          fillOpacity={0.75}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_2286_5734">
          <Rect width={303.667} height={303.667} fill="#fff" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
